import React, { useContext, useState } from 'react';

import { AppContext } from '../../../context/app';
import { useOutsideClick } from '../../../hooks/useOutsideClick';
import { PlaceSearchStateEnum } from '../../sections/sectionGlobalSearch/types';
import ButtonStyled from '../button/Button';
import type { Option } from '../dropdownList/DropdownList';
import { DropdownList } from '../dropdownList/DropdownList';
import Icon from '../icon/Icon';
import { IconType } from '../icon/types';
import Title from '../title/Title';
import styles from './campusSelectorDropdown.module.scss';

export const CampusSelectorDropdown: React.FC = () => {
  const [open, setOpen] = useState(false);

  const {
    selectedSite,
    setSelectedSite,
    setSelectedBuilding,
    setSelectedFloor,
    setSelectedLocation,
    availableSites,
    setPlaceSearchState,
    setGlobalSearchText,
  } = useContext(AppContext);

  const siteOptions: Option[] | undefined =
    availableSites &&
    availableSites.map((site) => ({
      value: site.id,
      label: site.name,
    }));

  const selectedOption: Option | undefined = selectedSite && {
    value: selectedSite.id,
    label: selectedSite.name,
  };

  const handleDropDownSelection = (option: Option) => {
    const userSelectedSite = availableSites?.find(
      (site) => site.id === option.value,
    );
    setPlaceSearchState(PlaceSearchStateEnum.DISPLAYCATEGORIES);
    setGlobalSearchText(undefined);
    setSelectedSite(userSelectedSite);
    setSelectedBuilding(userSelectedSite?.buildings[-1]);
    setSelectedFloor(undefined);
    setSelectedLocation(undefined);
    setOpen(false);
  };

  const searchRef = useOutsideClick(() => setOpen(false));
  const handleOpenOptions = () => {
    setOpen(!open);
  };

  return (
    <div className={`${styles.container} `} ref={searchRef}>
      <ButtonStyled onClick={handleOpenOptions} variant={'text'}>
        <Title>{`${selectedSite?.short_name || selectedSite?.name}`}</Title>

        <div className={styles.iconContainer}>
          <Icon
            icon={open ? IconType.UP : IconType.DOWN}
            color="black"
            size={32}
          ></Icon>
        </div>
      </ButtonStyled>
      {open && siteOptions && (
        <DropdownList
          minScrollableLength={15}
          onSelectOption={handleDropDownSelection}
          options={siteOptions}
          selectedOption={selectedOption}
          overrideWidth={true}
        />
      )}
    </div>
  );
};
